<template>
  <div
    class="_rfp_mctb_slide_01_ rfp-mctb-carousel-slide"
    :class="[enableRtl ? 'rfp-mctb-carousel-slider-direction-rtl' : '']"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'rfp-mctb-slide',
  props: {
    enableRtl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
